var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{ref:"recaptcha",style:(_vm.getStyle),attrs:{"sitekey":_vm.getSiteKey},on:{"verify":_vm.verifyRecaptcha,"expired":_vm.reset}})}
var staticRenderFns = []

export { render, staticRenderFns }